import checkCircle from '../../assets/icons/check-circle.svg';
import piggyBank from '../../assets/icons/piggy-bank.svg';
import { useT } from '../../i18n';

/** Rule 12: social proof in dead time only — under the S0b and S3 lookup spinners. */
export function TrustPills() {
  const t = useT();
  return (
    <ul className="pills pills--ink" aria-hidden="true">
      <li>
        <img src={checkCircle} alt="" />
        {t('S3.trust.free')}
      </li>
      <li>
        <img src={piggyBank} alt="" />
        {t('S3.trust.noWinNoFee')}
      </li>
    </ul>
  );
}
